module.exports = __webpack_public_path__ + "media/images/views/dashboard/star-5-7c5de3289b70bf60b4c3ccd8292be445.svg";